/**
 * 示例模块
 * @author 意毅深
 * @date 2022/01/26 09:22
 */
const state = {
  sampleStateContent: 'Hello (From Module State)'
}
const mutations = {}
const actions = {}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sample.js